module.exports = __webpack_public_path__ + "static/realestate-730faaed1154e699d6f1174cd4b1113f.gif";